export const ARENA_TYPES = {
  WIDE_ARENA: "wide-arena"
};

